/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_Gk_71_107 as Componente_Gk_71_107,
  rec_Componente_Qk_81_107 as Componente_Qk_81_107,
  rec_Componente_Zk_90_107 as Componente_Zk_90_107,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FormularioUsuario as FormularioUsuario,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_React as React,
  rec_SesionesUsuario as SesionesUsuario,
  rec_Ti as Ti,
  rec__i as _i,
  rec_api as api,
  rec_wi as wi,
  rec_zo as zo,
  rec_Lo as claseEntrada,
} from "../../runtime/index.jsx";
import { PermisosUsuario } from "./PermisosUsuario.jsx";
import { verComo } from "./verComo.js";
import { rec_esAdministrador as esAdministrador } from "../../runtime/index.jsx";
export function Usuarios() {
  let { confirmar: e } = Fo(),
    [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(null),
    [f, p] = (0, React.useState)(null),
    [pm, setPm] = (0, React.useState)(null),
    [resumenApp, setResumenApp] = (0, React.useState)(null),
    // Buscador y filtros (2026-10-31): con la lista creciendo, se busca por
    // nombre, usuario, correo, celular, área o cargo y se filtra por área,
    // módulo de permisos y estado.
    [contexto, setContexto] = (0, React.useState)({}),
    [unidades, setUnidades] = (0, React.useState)([]),
    [buscar, setBuscar] = (0, React.useState)(``),
    [area, setArea] = (0, React.useState)(``),
    [modulo, setModulo] = (0, React.useState)(``),
    [estado, setEstado] = (0, React.useState)(`activos`),
    m = (0, React.useCallback)(async () => {
      o(!0);
      try {
        (n(await api(`/usuarios`)), c(``));
        api(`/personal/contexto-usuarios`, { sinCache: !0 })
          .then((r) => { setContexto(Object.fromEntries(r.usuarios.map((x) => [x.usuarioId, x]))); setUnidades(r.unidades); })
          .catch(() => { setContexto({}); setUnidades([]); });
        api(`/dispositivos/resumen-app`, { sinCache: !0 }).then(setResumenApp).catch(() => setResumenApp(null));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    m();
  }, [m]);
  async function h(e) {
    try {
      (await api(`/usuarios/${e.id}/activo`, {
        method: `PATCH`,
      }),
        m());
    } catch (e) {
      c(e.message);
    }
  }
  async function g(t) {
    if (
      await e({
        titulo: `Eliminar a ${t.usuario}`,
        mensaje: `Se borran sus sesiones y sus asignaciones de sede. No se puede deshacer.`,
        confirmarTexto: `Eliminar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/usuarios/${t.id}`, {
          method: `DELETE`,
        }),
          m());
      } catch (e) {
        c(e.message);
      }
  }
  const ctx = (u) => contexto[u.id] ?? {};
  const sinTildes = (x) => String(x ?? ``).normalize(`NFD`).replace(/[\u0300-\u036f]/g, ``).toLowerCase();
  // Áreas del organigrama en árbol (con sangría), sólo las que tienen gente en ellas o en sus subáreas.
  const conGente = new Set(t.flatMap((u) => ctx(u).enArbol ?? []));
  const hijos = new Map();
  for (const x of unidades) {
    const padre = x.padreId != null && unidades.some((y) => y.id === x.padreId) ? x.padreId : null;
    if (!hijos.has(padre)) hijos.set(padre, []);
    hijos.get(padre).push(x);
  }
  const areas = [];
  const recorrer = (padre, nivel) => {
    for (const x of (hijos.get(padre) ?? []).sort((a, b) => a.nombre.localeCompare(b.nombre))) {
      if (conGente.has(x.id)) areas.push({ id: x.id, nombre: x.nombre, nivel });
      if (nivel < 20) recorrer(x.id, nivel + 1);
    }
  };
  recorrer(null, 0);
  const modulos = [...new Set(t.flatMap((u) => ctx(u).modulos ?? []))].sort((x, y) => x.localeCompare(y));
  const palabras = sinTildes(buscar).split(/\s+/).filter(Boolean);
  const vis = t
    .filter((u) => (estado === `todos` ? true : estado === `activos` ? u.activo : estado === `inactivos` ? !u.activo : !u.celular))
    // Un área incluye a la gente de todas sus subáreas (enArbol trae cada área de la persona y las que la contienen).
    .filter((u) => !area || (area === `__sin` ? !ctx(u).area : (ctx(u).enArbol ?? []).includes(Number(area))))
    .filter((u) => !modulo || (modulo === `__sin` ? !u.superadmin && !(ctx(u).modulos ?? []).length : u.superadmin || (ctx(u).modulos ?? []).includes(modulo)))
    .filter((u) => {
      if (!palabras.length) return true;
      const c = ctx(u);
      const texto = sinTildes([u.nombre, u.apellido, u.usuario, u.correo, (u.celular ?? ``).replace(/\D/g, ``), c.areaRuta, ...(c.areas ?? []), c.cargo, ...(c.responsableDe ?? [])].join(` `));
      return palabras.every((w) => texto.includes(w));
    })
    .sort((x, y) => `${x.nombre} ${x.apellido}`.localeCompare(`${y.nombre} ${y.apellido}`));
  const hayFiltro = buscar || area || modulo || estado !== `activos`;
  const exportar = () => {
    const filas = [[`Nombre`, `Usuario`, `Correo`, `Celular`, `Áreas`, `Ruta del área principal`, `Cargo`, `Responsable de`, `Módulos con permisos`, `Estado`]];
    for (const u of vis) {
      const c = ctx(u);
      filas.push([`${u.nombre} ${u.apellido}`, u.usuario, u.correo, u.celular ?? ``, (c.areas ?? []).join(`; `), c.areaRuta ?? ``, c.cargo ?? ``, (c.responsableDe ?? []).join(`; `),
        u.superadmin ? `Superadmin (todo)` : (c.modulos ?? []).join(`; `), u.activo ? `activo` : `inactivo`]);
    }
    const csv = filas.map((f) => f.map((v) => `"${String(v).replace(/"/g, `""`)}"`).join(`,`)).join(`\r\n`);
    const a = document.createElement(`a`);
    a.href = URL.createObjectURL(new Blob([`\ufeff${csv}`], { type: `text/csv;charset=utf-8` }));
    a.download = `usuarios-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  };
  const Area = ({ u }) => {
    const c = ctx(u);
    if (!c.area) return <span className={`text-xs text-(--text)`}>—</span>;
    return (
      <span className={`flex flex-col`} title={[c.areaRuta, (c.areas ?? []).length > 1 ? `Áreas: ${c.areas.join(`, `)}` : null, ...(c.responsableDe ?? []).map((r) => `Responsable de ${r}`)].filter(Boolean).join(`\n`)}>
        <span className={`text-(--text-h)`}>{c.area}{(c.areas ?? []).length > 1 && <span className={`text-xs text-(--text)`}> +{c.areas.length - 1}</span>}</span>
        {c.cargo && <span className={`text-xs text-(--text)`}>{c.cargo}</span>}
      </span>
    );
  };
  const Modulos = ({ u }) => {
    if (u.superadmin) return <span className={`rounded-full bg-(--accent-bg) px-2 py-0.5 text-[11px] text-(--accent)`}>Superadmin · todo</span>;
    const l = ctx(u).modulos ?? [];
    if (!l.length) return <span className={`text-xs text-(--text)`}>Sin permisos</span>;
    return (
      <span className={`flex flex-wrap gap-1`} title={l.join(`\n`)}>
        {l.slice(0, 3).map((x) => <span key={x} className={`rounded-full border border-(--border) px-2 py-0.5 text-[11px] text-(--text-h)`}>{x}</span>)}
        {l.length > 3 && <span className={`px-1 text-[11px] text-(--text)`}>+{l.length - 3}</span>}
      </span>
    );
  };
  return (
    <div
      className={`flex flex-col gap-3`}
      children={[
        <EstadoError mensaje={s} onReintentar={m} />,
        resumenApp && (
          <p className={`flex flex-wrap gap-x-4 gap-y-1 text-xs text-(--text)`} title={`Personas con actividad en los últimos 30 días`}>
            <span><strong className={`text-(--text-h)`}>{resumenApp.conApp}</strong> usan la app instalada</span>
            <span><strong className={`text-(--text-h)`}>{resumenApp.soloNavegador}</strong> sólo el navegador</span>
            <span><strong className={`text-(--text-h)`}>{resumenApp.conAvisos}</strong> con avisos activos</span>
            {resumenApp.sinInformar > 0 && <span>{resumenApp.sinInformar} todavía sin informar</span>}
          </p>
        ),
        <div className={`flex flex-wrap items-center gap-2`}>
          <div style={{ flex: `1 1 18rem` }}><input type={`search`} className={`${claseEntrada} min-w-0`} value={buscar} onChange={(x) => setBuscar(x.target.value)}
            placeholder={`Buscar: nombre, correo, celular, área…`} title={`Busca en nombre, usuario, correo, celular, área, cargo y unidades a cargo`} aria-label={`Buscar usuarios`} /></div>
          <div style={{ flex: `0 1 17rem`, minWidth: `12rem` }}><select className={`${claseEntrada} w-full`} value={area} onChange={(x) => setArea(x.target.value)} aria-label={`Área`}>
            <option value={``}>Todas las áreas</option>
            {areas.map((x) => <option key={x.id} value={x.id}>{`\u00a0\u00a0`.repeat(x.nivel)}{x.nombre}</option>)}
            <option value={`__sin`}>Sin área asignada</option>
          </select></div>
          <div style={{ flex: `0 1 13rem`, minWidth: `10rem` }}><select className={`${claseEntrada} w-full`} value={modulo} onChange={(x) => setModulo(x.target.value)} aria-label={`Con permisos en`}>
            <option value={``}>Cualquier permiso</option>
            {modulos.map((x) => <option key={x} value={x}>Con permisos en {x}</option>)}
            <option value={`__sin`}>Sin ningún permiso</option>
          </select></div>
          <div style={{ flex: `0 1 13rem`, minWidth: `10rem` }}><select className={`${claseEntrada} w-full`} value={estado} onChange={(x) => setEstado(x.target.value)} aria-label={`Estado`}>
            <option value={`activos`}>Activos</option>
            <option value={`inactivos`}>Inactivos</option>
            <option value={`sinCelular`}>Sin celular</option>
            <option value={`todos`}>Todos</option>
          </select></div>
          <button type={`button`} onClick={() => u({})} className={zo} children={[<Ti className={`mr-1 inline h-3.5 w-3.5`} />, ` Nuevo usuario`]} />
        </div>,
        !a && t.length > 0 && (
          <div className={`flex flex-wrap items-center justify-between gap-2 text-xs text-(--text)`}>
            <span>
              Mostrando <strong className={`text-(--text-h)`}>{vis.length}</strong> de {t.length}
              {hayFiltro && <button type={`button`} className={`ml-2 underline hover:text-(--accent)`} onClick={() => { setBuscar(``); setArea(``); setModulo(``); setEstado(`activos`); }}>Quitar filtros</button>}
            </span>
            <button type={`button`} className={`rounded-lg px-2 py-1 hover:bg-(--accent-bg) hover:text-(--accent)`} onClick={exportar} disabled={!vis.length}>Exportar lo que se ve (CSV)</button>
          </div>
        ),
        a ? (
          <Componente_Zk_90_107 />
        ) : t.length === 0 ? (
          <Componente_Qk_81_107 texto={`Todavía no hay usuarios.`} />
        ) : vis.length === 0 ? (
          <Componente_Qk_81_107 texto={`Nadie coincide con la búsqueda o los filtros.`} />
        ) : (
          <JSXRuntime.Fragment
            children={[
              <ul
                className={`flex flex-col gap-2 sm:hidden`}
                children={vis.map((e) => (
                  <li
                    key={e.id}
                    className={`rounded-xl border border-(--border) p-3`}
                    children={[
                      <div
                        className={`flex items-start gap-2`}
                        children={[
                          <div
                            className={`min-w-0 flex-1`}
                            children={[
                              <p
                                className={`font-medium text-(--text-h)`}
                                children={[e.nombre, ` `, e.apellido]}
                              />,
                              <p
                                className={`truncate text-xs text-(--text)`}
                                children={[e.usuario, ` · `, e.correo]}
                              />,
                              <p
                                className={`mt-0.5 flex flex-wrap items-center gap-2 text-xs text-(--text)`}
                                children={[
                                  <Componente_Gk_71_107 numero={e.celular} />,
                                  ctx(e).area && <span>{ctx(e).area}{ctx(e).cargo ? ` · ${ctx(e).cargo}` : ``}</span>,
                                ]}
                              />,
                              <div className={`mt-1`}><Modulos u={e} /></div>,
                            ]}
                          />,
                          <button
                            type={`button`}
                            onClick={() => h(e)}
                            className={`shrink-0 rounded-full px-2 py-1 text-[11px] ${e.activo ? `bg-(--success-bg) text-(--success)` : `bg-(--panel) text-(--text)`}`}
                            children={e.activo ? `activo` : `inactivo`}
                          />,
                        ]}
                      />,
                      <div
                        className={`mt-2 flex justify-end gap-1`}
                        children={[
                          <button
                            type={`button`}
                            onClick={() => setPm(e)}
                            className={`rounded-lg px-2 py-1 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                            children={`Permisos`}
                          />,
                          esAdministrador() && !e.superadmin && e.activo && (
                            <button type={`button`} onClick={() => verComo(e).catch((x) => c(x.message))} title={`Ver el sistema como ${e.usuario} (sólo lectura)`}
                              className={`rounded-lg px-2 py-1 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`} children={`Ver como`} />
                          ),
                          <button
                            type={`button`}
                            onClick={() => p(e)}
                            aria-label={`Dispositivos de ${e.usuario}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                            children={(0, JSXRuntime.jsx)(_i, {
                              className: `h-4 w-4`,
                            })}
                          />,
                          <button
                            type={`button`}
                            onClick={() =>
                              u({
                                editar: e,
                              })
                            }
                            aria-label={`Editar ${e.usuario}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                            children={(0, JSXRuntime.jsx)(wi, {
                              className: `h-4 w-4`,
                            })}
                          />,
                          <button
                            type={`button`}
                            onClick={() => g(e)}
                            aria-label={`Eliminar ${e.usuario}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                            children={<Ki className={`h-4 w-4`} />}
                          />,
                        ]}
                      />,
                    ]}
                  />
                ))}
              />,
              <div
                className={`hidden overflow-x-auto sm:block`}
                children={
                  <table
                    className={`w-full min-w-[640px] text-sm`}
                    children={[
                      <thead
                        children={
                          <tr
                            className={`border-b border-(--border) text-left text-xs uppercase tracking-wide text-(--text)`}
                            children={[
                              <th
                                className={`py-2 pr-3`}
                                children={`Nombre, usuario y correo`}
                              />,
                              <th
                                className={`py-2 pr-3`}
                                children={`Celular`}
                              />,
                              <th className={`py-2 pr-3`} children={`Área`} />,
                              <th className={`py-2 pr-3`} children={`Permisos en`} />,
                              <th
                                className={`py-2 pr-3`}
                                children={`Estado`}
                              />,
                              <th className={`py-2`} />,
                            ]}
                          />
                        }
                      />,
                      <tbody
                        children={vis.map((e) => (
                          <tr
                            key={e.id}
                            className={`border-b border-(--border)/60 transition-colors hover:bg-(--accent-bg)`}
                            children={[
                              <td className={`py-2 pr-3`}>
                                <span className={`block text-(--text-h)`}>{e.nombre} {e.apellido}</span>
                                <span className={`block text-xs text-(--text)`}>{e.usuario} · {e.correo}</span>
                              </td>,
                              <td
                                className={`py-2 pr-3`}
                                children={
                                  <Componente_Gk_71_107 numero={e.celular} />
                                }
                              />,
                              <td className={`py-2 pr-3`} children={<Area u={e} />} />,
                              <td className={`py-2 pr-3`} children={<Modulos u={e} />} />,
                              <td
                                className={`py-2 pr-3`}
                                children={
                                  <button
                                    type={`button`}
                                    onClick={() => h(e)}
                                    className={`rounded-full px-2 py-0.5 text-[11px] ${e.activo ? `bg-(--success-bg) text-(--success)` : `bg-(--panel) text-(--text)`}`}
                                    children={e.activo ? `activo` : `inactivo`}
                                  />
                                }
                              />,
                              <td
                                className={`whitespace-nowrap py-2 text-right`}
                                children={[
                                  <button
                                    type={`button`}
                                    onClick={() => setPm(e)}
                                    title={`Permisos por acción`}
                                    className={`rounded-lg px-2 py-0.5 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                                    children={`Permisos`}
                                  />,
                                  esAdministrador() && !e.superadmin && e.activo && (
                                    <button type={`button`} onClick={() => verComo(e).catch((x) => c(x.message))} title={`Ver el sistema como ${e.usuario} (sólo lectura)`}
                                      className={`rounded-lg px-2 py-0.5 text-xs text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`} children={`Ver como`} />
                                  ),
                                  <button
                                    type={`button`}
                                    onClick={() => p(e)}
                                    aria-label={`Dispositivos y sesiones`}
                                    title={`Dispositivos y sesiones`}
                                    className={`rounded-lg p-1 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                                    children={(0, JSXRuntime.jsx)(_i, {
                                      className: `h-3.5 w-3.5`,
                                    })}
                                  />,
                                  <button
                                    type={`button`}
                                    onClick={() =>
                                      u({
                                        editar: e,
                                      })
                                    }
                                    aria-label={`Editar`}
                                    className={`rounded-lg p-1 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                                    children={(0, JSXRuntime.jsx)(wi, {
                                      className: `h-3.5 w-3.5`,
                                    })}
                                  />,
                                  <button
                                    type={`button`}
                                    onClick={() => g(e)}
                                    aria-label={`Eliminar`}
                                    className={`rounded-lg p-1 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                                    children={<Ki className={`h-3.5 w-3.5`} />}
                                  />,
                                ]}
                              />,
                            ]}
                          />
                        ))}
                      />,
                    ]}
                  />
                }
              />,
            ]}
          />
        ),
        l && (
          <FormularioUsuario
            editar={l.editar}
            onClose={() => u(null)}
            onGuardado={() => {
              (u(null), m());
            }}
          />
        ),
        f && <SesionesUsuario usuario={f} onClose={() => p(null)} />,
        pm && <PermisosUsuario usuario={pm} onClose={() => setPm(null)} />,
      ]}
    />
  );
}
